.img {
  max-width: 100%;
  height: auto;
}

.pages-banner {
  .pages-banner-items {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    align-items: center;

    .pages-banner-item {
      width: 50%;
      float: left;

      .pages-banner-info {
        padding-left: 32%;

        span {
          display: block;
          font-weight: 600;
          margin-bottom: 8px;
          color: #222222;
        }

        h2 {
          font-size: 44px;
          line-height: 1.21;
          font-weight: 600;
          margin-top: 0;
          margin-bottom: 24px;
          color: #222222;
          max-width: 552px;
        }

        p {
          max-width: 552px;
          color: #222222;
          font-weight: 500;
          font-size: 18px;
          line-height: 1.5;
        }
      }
    }
  }
}

@media (max-width: 1650px) {
  .pages-banner {
    .pages-banner-items {
      .pages-banner-item {
        .pages-banner-info {
          padding-left: 14%;
        }
      }
    }
  }
}

@media (max-width: 1199px) {
  .pages-banner {
    .pages-banner-items {
      .pages-banner-item {
        .pages-banner-info {
          padding-left: 20px;

          h2 {
            font-size: 31px;
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .pages-banner {
    .pages-banner-items {
      .pages-banner-item {
        width: 100%;

        &.banner-info {
          order: 2;
        }
        &.banner-image {
          order: 1;
        }

        .pages-banner-info {
          padding-right: 20px;
        }
      }
    }
  }
}

@media (max-width: 639px) {
  .pages-banner {
    .pages-banner-items {
      .pages-banner-item {
        .pages-banner-info {
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}

@media (max-width: 479px) {
  .pages-banner {
    .pages-banner-items {
      .pages-banner-item {
        .pages-banner-info {
          h2 {
            font-size: 26px;
          }
        }
      }
    }
  }
}
